export enum EventActionedBy {
  Customer = 'Customer',
  Agent = 'Agent',
  PartnerAgent = 'Partner Agent',
}

export enum EventSource {
  Dash = 'Dash',
  SalesforceService = 'Salesforce Service',
  ServiceLayer = 'Service Layer',
  Desk = 'Desk',
  PartnerAPI = 'Partner API',
}

// Server-side decline-referral funnel events. Render as `Decline Referral - <name> - Server side`.
export enum DeclineReferralEventName {
  Eligible = 'Eligible',
  Sent = 'Sent',
}

// Referral partner-status lifecycle events. Render as `Referral Status - <name> - Server side`.
export enum ReferralStatusEventName {
  CustomerPending = 'Customer pending',
  ReferralSentToPartner = 'Referral sent to partner',
  ReferralToPartnerSuccess = 'Referral to partner success',
}

export enum LoanApplicationEventName {
  Received = 'Received',
  QuoteRequested = 'Quote requested',
  Quoted = 'Quoted',
  Started = 'Started',
  FormCompleted = 'Form completed',
  AcceptedHandover = 'Accepted handover',
  AcceptedLender = 'Accepted lender',
  AwaitingDocuments = 'Awaiting documents',
  BankStatementsSubmitted = 'Bank statements submitted',
  BankStatementsReceived = 'Bank statements received',
  UnderReview = 'Under review',
  Submitted = 'Submitted',
  Approved = 'Approved',
  Settled = 'Settled',
  Declined = 'Declined',
  Withdrawn = 'Withdrawn',
  Closed = 'Closed',
  TeslaCustomerArrived = 'Tesla customer arrived',
  TeslaOrderChanged = 'Tesla order changed',
  ContractStatusChanged = 'Contract status changed',
}

export enum LoanApplicationOrigin {
  QuoteJourney = 'Quote Journey',
  PartnerAPI = 'Partner API',
}

export enum LoanApplicationBankStatementsRequirement {
  NotRequired = 'Not required',
  Skipped = 'Skipped',
  Required = 'Required',
}

export enum LoanApplicationSubmissionType {
  Lodged = 'Lodged',
  Referred = 'Referred',
}

export enum LoanApplicationSettlementType {
  Direct = 'Direct',
  Referral = 'Referral',
}

export enum AgentEventName {
  PayslipOneOpened = 'Payslip One opened',
  PayslipTwoOpened = 'Payslip Two opened',
}

export enum PayslipEventName {
  ValidationFailed = 'Payslip validation failed',
  ReuploadCompleted = 'Payslip reupload completed',
  ValidationAcknowledged = 'Payslip validation acknowledged',
}
